import { DynamicPageProps } from '@doltech/routeDefinition';
import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { RelatedPosts } from '@doltech/ui/lib/shared/components/RelatedPosts/RelatedPosts';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import objectMapper from 'object-mapper';
import * as React from 'react';

import dataMapping from '../model/related-posts.mapping.json';
import { ContactDol } from '@doltech/ui/lib/figma/ContactDol/ContactDol';

interface LandingIeltsSampleDetailLayoutProps extends DynamicPageProps {
  children?: React.ReactNode;
  preview?: boolean;
}

export const LandingIeltsSampleDetailLayout = (props: LandingIeltsSampleDetailLayoutProps) => {
  const { children, pageData, internalPageLink, preview = false } = props;

  const { relatedPosts, detailData } = pageData;

  const mappedRelatedPosts = objectMapper(relatedPosts, dataMapping);

  return (
    <>
      {children}
      <ContactDol />
      {!preview && (
        <Box position="relative" className="sticky-on" id="content-footer" bg="gray5" p="40px 0 0">
          <RelatedPosts
            data={mappedRelatedPosts}
            metadata={[]}
            readMore={{
              url: getLandingUrlFromPath(
                internalPageLink.staticPageLink?.[`LANDING_${detailData.contentGroup}_SAMPLE`]?.url,
                'landing'
              ),
              text:
                detailData.contentGroup.toLowerCase() === 'writing'
                  ? 'Đọc thêm từ IELTS Writing Sample'
                  : 'Đọc thêm từ IELTS Speaking Sample',
            }}
          />
        </Box>
      )}
    </>
  );
};
